var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-page"},[(_vm.roleKind === 'super')?_c('div',[_c('SuperHome')],1):(_vm.roleKind === 'null')?_c('div',[_c('NoneRoleHome')],1):_c('div',[_c('ApplicationHome')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }